import {
  DashboardOutlined,
  WalletOutlined,
  SettingOutlined,
  CloudUploadOutlined,
  TeamOutlined,
  UserAddOutlined,
  MailOutlined,
  ContainerOutlined,
  PercentageOutlined,
  PlusCircleOutlined,
  DeliveredProcedureOutlined,
  SoundOutlined,
  GiftOutlined,
  SendOutlined,
  CreditCardOutlined,
  ShopOutlined,
  AuditOutlined,
  FileTextOutlined,
  CustomerServiceOutlined,
  PrinterOutlined,
  SwapOutlined,
  InboxOutlined,
  BankOutlined,
  UnorderedListOutlined,
  MinusCircleOutlined,
  FolderOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  DollarOutlined,
  BarChartOutlined,
  ClockCircleOutlined,
  FundOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { BANK_RECONCILIATION_ROLES } from 'constants/BankReconciliationConstant'
import ReviewQueueBadge from 'views/app-views/bank-reconciliation/components/ReviewQueueBadge'


const dashboardNavTree = [
  {
    key: 'dashboard',
    path: `${APP_PREFIX_PATH}/dashboard`,
    title: 'nav.dashboard',
    icon: DashboardOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_SALESMAN',
      'role_shop',
      'ROLE_ADMIN',
      'role_view_sales_dashboard',
      'role_view_analytics_dashboard',
    ],
    submenu: [

      {
        key: 'dashboard-admin',
        path: `${APP_PREFIX_PATH}/dashboard/admin`,
        title: 'nav.admin_dashboard',
        icon: DashboardOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_admin_dashboard',
        ],
        submenu: []
      },
      {
        key: 'dashboard-accounting',
        path: `${APP_PREFIX_PATH}/dashboard/accounting`,
        title: 'nav.accounting_dashboard',
        icon: DashboardOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'dashboard-salesman',
        path: `${APP_PREFIX_PATH}/dashboard/salesman`,
        title: 'nav.salesman_dashboard',
        icon: DashboardOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_SALESMAN',
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'dashboard-shop',
        path: `${APP_PREFIX_PATH}/dashboard/shop`,
        title: 'nav.shop_dashboard',
        icon: DashboardOutlined,
        breadcrumb: false,
        premission: [
          'role_shop',
          'role_view_analytics_dashboard',
          'ROLE_ADMIN',
        ],
        submenu: []
      },
    ]
  },
]

const managerNavTree = [
  {
    key: 'manager',
    path: `${APP_PREFIX_PATH}/managers`,
    title: 'nav.managers_management',
    icon: TeamOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
      'role_view_manager',
      'role_create_manager',
      'role_edit_manager',
    ],
    submenu: [
      {
        key: 'manager-add',
        path: `${APP_PREFIX_PATH}/managers/add`,
        title: 'nav.add_manager',
        icon: UserAddOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_create_manager',
        ],
        submenu: []
      },
      {
        key: 'manager-list',
        path: `${APP_PREFIX_PATH}/managers/list`,
        title: 'nav.all_managers',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_manager',
        ],
        submenu: []
      },
    ]
  },
]

const salesmanNavTree = [
  {
    key: 'salesman',
    path: `${APP_PREFIX_PATH}/salesmen`,
    title: 'nav.salesmen_management',
    icon: TeamOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_SALESMAN',
      'ROLE_ADMIN',
      'role_view_salesman',
      'role_create_salesman',
      'role_edit_salesman',
      'role_view_salesman_commissions',
      'role_edit_salesman_commissions'
    ],
    submenu: [
      {
        key: 'salesman-add',
        path: `${APP_PREFIX_PATH}/salesmen/add`,
        title: 'nav.add_salesman',
        icon: UserAddOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_create_salesman',
        ],
        submenu: []
      },
      {
        key: 'salesman-list',
        path: `${APP_PREFIX_PATH}/salesmen/list`,
        title: 'nav.all_salesmen',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_salesman',
        ],
        submenu: []
      },
      {
        key: 'salesman-commissions',
        path: `${APP_PREFIX_PATH}/salesmen/commissions`,
        title: 'nav.salesmen_commissions',
        icon: PercentageOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_edit_salesman_commissions'
        ],
        submenu: []
      },
      {
        key: 'salesman-commissions-shop',
        path: `${APP_PREFIX_PATH}/salesmen/commissions-shop`,
        title: 'nav.commissions',
        icon: PercentageOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'ROLE_SALESMAN',
          'role_view_salesman_commissions',
        ],
        submenu: []
      },
    ]
  },
]

const shopNavTree = [
  {
    key: 'shop',
    path: `${APP_PREFIX_PATH}/shops`,
    title: 'nav.shops_management',
    icon: ShopOutlined,
    breadcrumb: false,
    premission: [
      'role_shop',
      'ROLE_ADMIN',
      'role_view_shop',
      'role_create_shop',
      'role_edit_shop',
      'role_view_terminal',
      'role_view_low_credit_shop',
      'role_manage_unverified_user',
    ],
    submenu: [
      {
        key: 'shop-add',
        path: `${APP_PREFIX_PATH}/shops/add`,
        title: 'nav.add_shops',
        icon: UserAddOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_create_shop',
        ],
        submenu: []
      },
      {
        key: 'shop-list',
        path: `${APP_PREFIX_PATH}/shops/list`,
        title: 'nav.all_shops',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_shop',
        ],
        submenu: []
      },
      {
        key: 'unverified-shop-list',
        path: `${APP_PREFIX_PATH}/shops/unverified`,
        title: 'nav.unverified_shops',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_manage_unverified_user',
        ],
        submenu: []
      },
      {
        key: 'terminal-list',
        path: `${APP_PREFIX_PATH}/terminals/list`,
        title: 'nav.all_terminals',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'role_shop',
          'ROLE_ADMIN',
          'role_view_terminal',
        ],
        submenu: []
      },
      {
        key: 'low-credit-shop-list',
        path: `${APP_PREFIX_PATH}/shops/low-credit`,
        title: 'nav.low_credit_shops',
        icon: WalletOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_low_credit_shop',
        ],
        submenu: []
      },
    ]
  },
]


const supportNavTree = [
  {
    key: 'support',
    path: `${APP_PREFIX_PATH}/supports`,
    title: 'nav.supports_management',
    icon: CustomerServiceOutlined,
    breadcrumb: false,
    premission: [
      'role_shop',
      'ROLE_ADMIN',
      'role_view_support',
      'role_create_support',
      'role_edit_support',
    ],
    submenu: [
      {
        key: 'support-list',
        path: `${APP_PREFIX_PATH}/supports/list/open`,
        title: 'nav.supports_tickets',
        icon: MailOutlined,
        breadcrumb: false,
        premission: [
          'role_shop',
          'ROLE_ADMIN',
          'role_view_support',
          'role_create_support',
          'role_edit_support',
        ],
        submenu: []
      },
    ]
  },
]

const auditLogNavTree = [
  {
    key: 'audit-log',
    path: `${APP_PREFIX_PATH}/audit-logs`,
    title: 'nav.audit_log',
    icon: AuditOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
      'role_view_audit_log',
    ],
    submenu: [
      {
        key: 'audit-log-list',
        path: `${APP_PREFIX_PATH}/audit-logs/list`,
        title: 'nav.audit_log',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_audit_log',
        ],
        submenu: []
      },
    ]
  },
]

const settingNavTree = [
  {
    key: 'setting',
    path: `${APP_PREFIX_PATH}/settings`,
    title: 'nav.settings_management',
    icon: SettingOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
      'role_view_setting',
      'role_edit_setting',
    ],
    submenu: [
      {
        key: 'setting-list',
        path: `${APP_PREFIX_PATH}/settings`,
        title: 'nav.settings',
        icon: SettingOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_setting',
          'role_edit_setting',
        ],
        submenu: []
      },
    ]
  },
]

const VoucherBatchNavTree = [
  {
    key: 'voucher-batches',
    path: `${APP_PREFIX_PATH}/voucher-batches`,
    title: 'nav.voucher_batches_management',
    icon: GiftOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
      'role_view_voucher_batch',
      'role_create_voucher_batch',
      'role_edit_voucher_batch',
      'role_view_voucher',
      'role_set_to_printed',
      'role_reprint_voucher',
    ],
    submenu: [
      {
        key: 'voucher-batches-add',
        path: `${APP_PREFIX_PATH}/voucher-batches/add`,
        title: 'nav.add_voucher_batch',
        icon: UserAddOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_create_voucher_batch',
        ],
        submenu: []
      },
      {
        key: 'voucher-batches-list',
        path: `${APP_PREFIX_PATH}/voucher-batches/list`,
        title: 'nav.all_voucher_batches',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_voucher_batch',
        ],
        submenu: []
      },
      {
        key: 'voucher-list',
        path: `${APP_PREFIX_PATH}/vouchers/list`,
        title: 'nav.vouchers_list',
        icon: ContainerOutlined,
        breadcrumb: false,
        premission: [
          'role_shop',
          'ROLE_ADMIN',
          'role_view_voucher',
          'role_set_to_printed',
          'role_reprint_voucher',
        ],
        submenu: []
      },
    ]
  },
]


const bulkNavTree = [
  {
    key: 'bulk',
    path: `${APP_PREFIX_PATH}/bulks`,
    title: 'nav.bulk_management',
    icon: PrinterOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_SALESMAN',
    ],
    submenu: [
      {
        key: 'request-bulk',
        path: `${APP_PREFIX_PATH}/bulks/bulks-requests`,
        title: 'nav.bulk_print',
        icon: PrinterOutlined,
        breadcrumb: false,
        exactAuth: true,
        premission: [
          'ROLE_SALESMAN',
        ],
        submenu: []
      },
      {
        key: 'bulk-list',
        path: `${APP_PREFIX_PATH}/bulks/list-bulks`,
        title: 'nav.all_bulks',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_SALESMAN',
        ],
        submenu: []
      },
    ]
  },
]

const TransactionNavTree = [
  {
    key: 'transaction',
    path: `${APP_PREFIX_PATH}/transactions`,
    title: 'nav.transactions_management',
    icon: SwapOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
      'role_shop',
      'role_view_transaction',
    ],
    submenu: [
      {
        key: 'transaction-list',
        path: `${APP_PREFIX_PATH}/transactions/list-transactions`,
        title: 'nav.all_transactions',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_shop',
          'role_view_transaction',
        ],
        submenu: []
      },
    ]
  },
]

const collectingNavTree = [
  {
    key: 'collecting',
    path: `${APP_PREFIX_PATH}/collect`,
    title: 'nav.collection_management',
    icon: InboxOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
      'role_view_collecting',
      'role_create_collecting',
      'role_edit_collecting',
    ],
    submenu: [
      {
        key: 'collecting-user-list',
        path: `${APP_PREFIX_PATH}/collect/user-list`,
        title: 'nav.user_collection_list',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_view_collecting',
        ],
        submenu: []
      },
      {
        key: 'collecting-add',
        path: `${APP_PREFIX_PATH}/collect/add`,
        title: 'nav.add_collecting_item',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_create_collecting',
        ],
        submenu: []
      },
      {
        key: 'collecting-list',
        path: `${APP_PREFIX_PATH}/collect/list`,
        title: 'nav.collecting_list',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'role_edit_collecting',
          'role_view_collecting',
        ],
        submenu: []
      },
    ]
  }
]

const accountNavTree = [
  {
    key: 'account',
    path: `${APP_PREFIX_PATH}/account`,
    title: 'nav.account_management',
    icon: BankOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
    ],
    submenu: [
      {
        key: 'account-list',
        path: `${APP_PREFIX_PATH}/account/list`,
        title: 'nav.account_list',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'account-add-transaction',
        path: `${APP_PREFIX_PATH}/account/add-transaction`,
        title: 'nav.make_account_transaction',
        icon: SwapOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'account-ledger',
        path: `${APP_PREFIX_PATH}/account/ledger`,
        title: 'nav.ledger',
        icon: DeliveredProcedureOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
    ]
  }
]

const expenseNavTree = [
  {
    key: 'expense',
    path: `${APP_PREFIX_PATH}/expense`,
    title: 'nav.expense_management',
    icon: MinusCircleOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
    ],
    submenu: [
      {
        key: 'expense-add',
        path: `${APP_PREFIX_PATH}/expense/add`,
        title: 'nav.add_expense',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'expense-list',
        path: `${APP_PREFIX_PATH}/expense/list`,
        title: 'nav.expense_list',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'expense-category-list',
        path: `${APP_PREFIX_PATH}/expense/category`,
        title: 'nav.expense_category',
        icon: FolderOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
    ]
  }
]

const incomeNavTree = [
  {
    key: 'income',
    path: `${APP_PREFIX_PATH}/income`,
    title: 'nav.income_management',
    icon: PlusCircleOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
    ],
    submenu: [
      {
        key: 'income-add',
        path: `${APP_PREFIX_PATH}/income/add`,
        title: 'nav.add_income',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'income-list',
        path: `${APP_PREFIX_PATH}/income/list`,
        title: 'nav.income_list',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'income-category-list',
        path: `${APP_PREFIX_PATH}/income/category`,
        title: 'nav.income_category',
        icon: FolderOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
    ]
  }
]

const paymentMethodNavTree = [
  {
    key: 'payment-method',
    path: `${APP_PREFIX_PATH}/payment-method`,
    title: 'nav.payment_methods',
    icon: CreditCardOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
    ],
    submenu: [
      {
        key: 'payment-method-add',
        path: `${APP_PREFIX_PATH}/payment-method/add`,
        title: 'nav.add_payment_method',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'payment-method-list',
        path: `${APP_PREFIX_PATH}/payment-method/list`,
        title: 'nav.payment_method_list',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
    ]
  }
]

const bankReconciliationNavTree = [
  {
    key: 'bank-reconciliation',
    path: `${APP_PREFIX_PATH}/bank-reconciliation`,
    title: 'nav.bank_reconciliation',
    defaultTitle: 'Bank reconciliation',
    icon: BankOutlined,
    breadcrumb: false,
    premission: BANK_RECONCILIATION_ROLES,
    submenu: [
      {
        key: 'bank-reconciliation-import',
        path: `${APP_PREFIX_PATH}/bank-reconciliation/import`,
        title: 'nav.bank_reconciliation_import',
        defaultTitle: 'Import a statement',
        icon: CloudUploadOutlined,
        breadcrumb: false,
        premission: BANK_RECONCILIATION_ROLES,
        submenu: []
      },
      {
        key: 'bank-reconciliation-review',
        path: `${APP_PREFIX_PATH}/bank-reconciliation/review`,
        title: 'nav.bank_reconciliation_review',
        defaultTitle: 'To review',
        icon: AuditOutlined,
        badge: ReviewQueueBadge,
        breadcrumb: false,
        premission: BANK_RECONCILIATION_ROLES,
        submenu: []
      },
      {
        key: 'bank-reconciliation-transactions',
        path: `${APP_PREFIX_PATH}/bank-reconciliation/transactions`,
        title: 'nav.bank_reconciliation_transactions',
        defaultTitle: 'Bank lines',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: BANK_RECONCILIATION_ROLES,
        submenu: []
      },
      {
        key: 'bank-reconciliation-unmatched-requests',
        path: `${APP_PREFIX_PATH}/bank-reconciliation/unmatched-requests`,
        title: 'nav.bank_reconciliation_unmatched_requests',
        defaultTitle: 'Requests without a line',
        icon: ClockCircleOutlined,
        breadcrumb: false,
        premission: BANK_RECONCILIATION_ROLES,
        submenu: []
      },
      {
        key: 'bank-reconciliation-payers',
        path: `${APP_PREFIX_PATH}/bank-reconciliation/payers`,
        title: 'nav.bank_reconciliation_payers',
        defaultTitle: 'Known payers',
        icon: TeamOutlined,
        breadcrumb: false,
        premission: BANK_RECONCILIATION_ROLES,
        submenu: []
      },
      {
        key: 'bank-reconciliation-fees',
        path: `${APP_PREFIX_PATH}/bank-reconciliation/fees`,
        title: 'nav.bank_reconciliation_fees',
        defaultTitle: 'Bank fees',
        icon: FundOutlined,
        breadcrumb: false,
        premission: BANK_RECONCILIATION_ROLES,
        submenu: []
      },
      {
        key: 'bank-reconciliation-settings',
        path: `${APP_PREFIX_PATH}/bank-reconciliation/settings`,
        title: 'nav.bank_reconciliation_settings',
        defaultTitle: 'Settings',
        icon: SettingOutlined,
        breadcrumb: false,
        premission: BANK_RECONCILIATION_ROLES,
        submenu: []
      },
    ]
  }
]

const creditRequestNavTree = [
  {
    key: 'credit-request',
    path: `${APP_PREFIX_PATH}/credit-request/`,
    title: 'nav.credit_request',
    icon: WalletOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_SALESMAN',
      'role_shop',
      'ROLE_ADMIN',
      'role_view_credit_request',
      'role_edit_credit_request',
    ],
    submenu: [
      {
        key: 'credit-request-topup',
        path: `${APP_PREFIX_PATH}/credit-request/topup`,
        title: 'nav.add_credit',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        exactAuth: true,
        premission: [
          'ROLE_ADD_CREDIT_REQUEST',
        ],
        submenu: []
      },
      {
        key: 'credit-request-list',
        path: `${APP_PREFIX_PATH}/credit-request/list`,
        title: 'nav.credit_requests',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'ROLE_SALESMAN',
          'role_shop',
          'role_view_credit_request',
        ],
        submenu: []
      },
    ]
  }
]

const productRequestNavTree = [
  {
    key: 'product-request',
    path: `${APP_PREFIX_PATH}/product-requests`,
    title: 'nav.product_requests_management',
    icon: PrinterOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
    ],
    submenu: [
      {
        key: 'product-request-list',
        path: `${APP_PREFIX_PATH}/product-requests/list`,
        title: 'nav.product_requests',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
    ]
  }
]

const inventoryNavTree = [
  {
    key: 'inventory',
    path: `${APP_PREFIX_PATH}/inventory`,
    title: 'nav.inventory_management',
    icon: AppstoreOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
    ],
    submenu: [
      {
        key: 'inventory-products',
        path: `${APP_PREFIX_PATH}/inventory/products`,
        title: 'nav.inventory_products',
        icon: AppstoreOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'inventory-purchases',
        path: `${APP_PREFIX_PATH}/inventory/purchases`,
        title: 'nav.inventory_purchases',
        icon: ShoppingCartOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'inventory-sales',
        path: `${APP_PREFIX_PATH}/inventory/sales`,
        title: 'nav.inventory_sales',
        icon: DollarOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'inventory-summary',
        path: `${APP_PREFIX_PATH}/inventory/summary`,
        title: 'nav.inventory_summary',
        icon: BarChartOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
    ]
  }
]

const notificationManagementNavTree = [
  {
    key: 'notification-management',
    path: `${APP_PREFIX_PATH}/notifications`,
    title: 'nav.notifications_management',
    icon: SoundOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
    ],
    submenu: [
      {
        key: 'notification-management-list',
        path: `${APP_PREFIX_PATH}/notifications/list`,
        title: 'nav.notifications_list',
        icon: MailOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'notification-management-add',
        path: `${APP_PREFIX_PATH}/notifications/add`,
        title: 'nav.create_notification',
        icon: SendOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
      {
        key: 'notification-management-settings',
        path: `${APP_PREFIX_PATH}/notifications/settings`,
        title: 'nav.notification_settings',
        icon: SettingOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      },
    ]
  }
]

const invoiceNavTree = [
  {
    key: 'invoices',
    path: `${APP_PREFIX_PATH}/invoices`,
    title: 'nav.invoices',
    icon: FileTextOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
      'ROLE_SHOP',
      'ROLE_VIEW_INVOICE',
    ],
    submenu: [
      {
        key: 'invoices-list',
        path: `${APP_PREFIX_PATH}/invoices/list`,
        title: 'nav.invoices_list',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'ROLE_SHOP',
          'ROLE_VIEW_INVOICE',
        ],
        submenu: []
      },
      {
        key: 'tej-declaration-list',
        path: `${APP_PREFIX_PATH}/tej-declaration/list`,
        title: 'nav.tej_declaration_list',
        icon: DeliveredProcedureOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
        ],
        submenu: []
      }
    ]
  }
]

const receivedInvoiceNavTree = [
  {
    key: 'received-invoice',
    path: `${APP_PREFIX_PATH}/received-invoice`,
    title: 'nav.received_invoices',
    icon: CloudUploadOutlined,
    breadcrumb: false,
    premission: [
      'ROLE_ADMIN',
      'ROLE_VIEW_INVOICE',
    ],
    submenu: [
      {
        key: 'received-invoice-add',
        path: `${APP_PREFIX_PATH}/received-invoice/add`,
        title: 'nav.create_received_invoice',
        icon: PlusCircleOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'ROLE_VIEW_INVOICE',
        ],
        submenu: []
      },
      {
        key: 'received-invoice-list',
        path: `${APP_PREFIX_PATH}/received-invoice/list`,
        title: 'nav.received_invoices_list',
        icon: UnorderedListOutlined,
        breadcrumb: false,
        premission: [
          'ROLE_ADMIN',
          'ROLE_VIEW_INVOICE',
        ],
        submenu: []
      }
    ]
  }
]



const navigationConfig = [
  ...dashboardNavTree,
  ...invoiceNavTree,
  ...receivedInvoiceNavTree,
  ...creditRequestNavTree,
  ...managerNavTree,
  ...salesmanNavTree,
  ...shopNavTree,
  ...VoucherBatchNavTree,
  ...TransactionNavTree,
  ...supportNavTree,
  ...auditLogNavTree,
  ...bulkNavTree,
  ...collectingNavTree,
  ...accountNavTree,
  ...expenseNavTree,
  ...incomeNavTree,
  ...paymentMethodNavTree,
  ...bankReconciliationNavTree,
  ...productRequestNavTree,
  ...inventoryNavTree,
  ...notificationManagementNavTree,
  ...settingNavTree,
]

export default navigationConfig;
